import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import DealerAd from '@wix/da-shared-react/pkg/DealerAd';
import { getTheme } from '@wix/da-shared-react/pkg/publicSession/selectors';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import { AppState } from '../../../../types/store';

import s from './AdBox.scss';

export interface Props {
  theme: ThemeOptions;
}

type State = { containerWidth?: number };

class AdBox extends React.Component<Props, State> {
  state: State = {};
  containerRef = React.createRef<HTMLDivElement>();

  componentDidMount() {
    this.setState({ containerWidth: this.containerRef.current!.offsetWidth });
  }

  render() {
    return (
      <div ref={this.containerRef} className={s['ad']}>
        {this.state.containerWidth && (
          <DealerAd realEstateId={this.getRealEstateId()} />
        )}
      </div>
    );
  }

  getRealEstateId = () => {
    if (this.props.theme === ThemeOptions.DARK) {
      return this.state.containerWidth! >= 600
        ? '18835146-c1f5-41d6-a5af-02b36b8ec652'
        : '31560bea-a436-45bf-9488-496963296430';
    } else {
      return this.state.containerWidth! >= 600
        ? '653152ce-50b5-414d-a81a-61a73fce2960'
        : 'ca8b5c0b-89ad-4a91-8ff2-24ed6db4b0d4';
    }
  };
}

const mapStateToProps: MapStateToProps<Props, {}, AppState> = state => ({
  theme: getTheme(state),
});

const enhance = connect(mapStateToProps);

export default enhance(AdBox);
